// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false;

var config = {
  direction: [
    'fromLeft',
    'fromRight'
  ],
  munitions: 5,
  positionTop: [
    'high',
    'middle',
    'low'
  ],
  time: 60
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  data: {
    config: config,
    initialMunitions: config.munitions,
    initialTime: config.time
  },
  template: '<App :config="config" :initialMunitions="initialMunitions" :initialTime="initialTime"/>'
});

document.getElementsByTagName('body')[0].oncontextmenu = function () {
  return false;
};



// WEBPACK FOOTER //
// ./src/main.js